export default __webpack_public_path__ + "static/media/homemidback.03e11701.jpg";